import React from 'react';

import { CircularProgressIndicator } from '../../../components/circular-progress-bar';

import styles from './download-overlay.module.scss';
interface DownloadOverlayProps {
  /**
   * Current progress to diplay as a percentage
   */
  progress: number;

  /**
   * Status of the uploading / downloading
   */
  status?: string;

  /**
   * Function to call when the user clicks on the pause button
   */
  onPause?: () => void;

  /**
   * Function to call when the user clicks on the resume button
   */
  onResume?: () => void;
}

export const DownloadOverlay: React.FC<DownloadOverlayProps> = ({
  progress,
  status,
  onPause,
  onResume,
}) => (
  <div className={styles['overlay']}>
    <CircularProgressIndicator
      progress={progress}
      onPause={onPause}
      onResume={onResume}
      status={status}
      displayProgress
    />
  </div>
);
